const { Player } = require('./player');
const { Analytics } = require('./analytics');
const { v4: uuidv4 } = require('uuid');

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

const API_URL = process.env.WIDGET_API_URL;

const wrapper = document.querySelector('#wrapper');
const playBtn = document.querySelector('#play-btn');
const playBtnBg = document.querySelector('#play-btn-bg');
const pauseBtn = document.querySelector('#pause-btn');
const pauseBtnBg = document.querySelector('#pause-btn-bg');
const progressBar = document.querySelector('#progress');
const timer = document.querySelector("#timer");
const spinner = document.querySelector('#spinner');
const rateSwitcher = document.querySelector('#rate');
const title = document.querySelector('#title');
const download = document.querySelector('#download');
const branding = document.querySelector('#branding');

const url = urlParams.get('url');
const orgId = urlParams.get('org_id');
const integrationId = urlParams.get('integration_id');
const hasPaywall = urlParams.get('has_paywall');
const contentId = urlParams.get('content_id');

var getOrgHash = function (orgId) {

    let hash = 0;

    orgId.split('').forEach(function (item, index) {
        hash = hash + item.charCodeAt();
    });

    return hash;
}

// Rollout partially
// const shouldServeV2 = (
//     ['ugSCv92ekW', '1p0xY4y4mz'].includes(orgId)
//     || [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50].includes(getOrgHash(orgId) % 100) 
// );

let widgetV2URL = process.env.WIDGET_V2_URL;

if (true) {
    // 100% V2 widget rollout

    console.debug('DEBUG', 'V2 Player')

    let script = document.createElement('script');
    script.setAttribute('src', `${widgetV2URL}/audioplayer.js`);

    document.head.appendChild(script);

    let webComponent = document.createElement('l2it-audio-player');
    webComponent.setAttribute('org_id', orgId);
    webComponent.setAttribute('integration_id', integrationId);
    webComponent.setAttribute('url', url);
    webComponent.setAttribute('has_paywall', hasPaywall);
    webComponent.setAttribute('content_id', contentId);
    document.body.appendChild(webComponent);

} else {

    console.debug('DEBUG', 'V1 Player')

    const analytics = new Analytics(orgId, integrationId, url, contentId);

    let pageContent;
    
    window.addEventListener('message', event => {
        
        pageContent = event.data;
    
    });
    
    const player = new Player();
    
    let progressTracker;
    
    function downloadAudio(url) {
        var link = document.createElement("a");
        link.href = url;
        link.download = url.slice(url.lastIndexOf('/') + 1);
        link.click();
    }
    
    download.addEventListener('click', async function(event) {
    
        event.preventDefault();
    
        if (null == player.getAudioURL()) {
    
            var interval = setIntervalAndExecute(async () => {
    
                let result = await fetch(`${API_URL}/organisation/${orgId}/integration/${integrationId}/audio/${encodeURIComponent(url)}`,{
                    method: 'POST',
                    body: JSON.stringify({
                        page_content: pageContent,
                        has_paywall: hasPaywall
                    })
                });
    
                const response =  await result.json();
    
                if (!response.success) {
                    return;
                }
    
                if("COMPLETED" === response.data.full_audio_status) {
                    
                    downloadAudio(response.data.full_audio_url)
                    clearInterval(interval);
    
                }
    
            }, 1500);
    
            return;   
        }
    
        downloadAudio(player.getAudioURL())
    
    });
    
    playBtn.addEventListener('click', async function(event){
    
        if(null==player.getAudioURL()){
    
            playBtn.style.display = "none";
            spinner.style.display = "block";
    
            const body = {
                page_content: pageContent,
                has_paywall: hasPaywall,
            }
    
            if (contentId) {
                body.contentId = contentId
            }
    
            let result = await fetch(`${API_URL}/organisation/${orgId}/integration/${integrationId}/audio/${encodeURIComponent(url)}`,{
                method: 'POST',
                body: JSON.stringify(body)
            });
    
            spinner.style.display = "none";
            playBtn.style.display = "block";
    
            const response =  await result.json();
    
            if (!response.success) {
                return;
            }
    
            if("COMPLETED" === response.data.full_audio_status){
    
                player.setAudioURL(response.data.full_audio_url);
                player.play();
    
                playBtn.style.display = "none";
                pauseBtn.style.display = "block";
    
                return;
    
            }
    
            player.setAudioURL(response.data.short_audio_url);
    
            setTimeout(async function(){
    
                const body = {
                    page_content: pageContent,
                    has_paywall: hasPaywall,
                }
        
                if (contentId) {
                    body.contentId = contentId
                }
    
                let result = await fetch(`${API_URL}/organisation/${orgId}/integration/${integrationId}/audio/${encodeURIComponent(url)}`,{
                    method: 'POST',
                    body: JSON.stringify(body)
                });
    
                const response =  await result.json();
    
                if (!response.success) {
                    return;
                }
    
                if("COMPLETED" === response.data.full_audio_status){
    
                    player.setAudioURL(response.data.full_audio_url)
                    player.switchAudio();
    
                }
    
            }, 60000);
    
        }
    
        player.play();
    
        playBtn.style.display = "none";
        pauseBtn.style.display = "block";
    
    });
    
    pauseBtn.addEventListener('click', function(event){
    
        if(progressTracker){
            clearInterval(progressTracker);
        }
    
        player.pause();
    
        playBtn.style.display = "block";
        pauseBtn.style.display = "none";
    
    
    });
    
    rateSwitcher.addEventListener('change', function(event){
    
        player.rate(event.target.value);
    
    });
    
    progressBar.addEventListener('input', function(event){
    
        player.seek(event.target.value);
    
    });
    
    player.onStep(function(time, progress, seek){
    
        timer.innerHTML = time;
        progressBar.value = seek;
    
    
    });
    
    player.onPlay(function(duration){
    
        progressBar.setAttribute('max', duration);
    
        analytics.record('PLAYED',{
            session_id: player.session_id,
        }).then(()=>{});
    
        progressTracker = setInterval(async function(){
    
            analytics.record('PROGRESS',{
                session_id: player.session_id,
                seek: player.getProgress()
            }).then(()=>{});
    
        }, 15000);
    
    
    });
    
    player.onPause(function(){
    
        if(progressTracker){
            clearInterval(progressTracker);
        }
    
    });
    
    player.onEnd(function(){
    
        if(progressTracker){
            clearInterval(progressTracker);
        }
    
        playBtn.style.display = "block";
        pauseBtn.style.display = "none";
    
    });
    
    
    window.onload = async (event) => {
    
        analytics.record('IMPRESSION').then(()=>{});
    
        const result = await fetch(`${API_URL}/organisation/${orgId}/integration/${integrationId}`);
        const response = await result.json();
    
        let audioPlayerSettings = response.data.audio_player_settings;
        let color = response.data.audio_player_settings.color;
    
        playBtnBg.style.fill = color;
        pauseBtnBg.style.fill = color;
    
        if (audioPlayerSettings.download_button) {
            download.style.display = 'inline-block';
        }
        
        if (audioPlayerSettings.remove_branding) {
            branding.style.display = 'none';
        }
    
        document.querySelectorAll('.spinner > div').forEach(el => el.style.backgroundColor = color);
        document.querySelector('.progress').style.color = color;
    
        title.innerHTML = audioPlayerSettings.title;
    
        wrapper.style.color = audioPlayerSettings.text_color;
        wrapper.style.display = "flex";
    
    }
    
    window.addEventListener("beforeunload", function (e) {
    
        if(progressTracker){
            clearInterval(progressTracker);
        }
    
        return null;
    
    });

}

function setIntervalAndExecute(fn, t) {
    fn();
    return(setInterval(fn, t));
}